module.exports = __webpack_public_path__ + "img/lg_ring_r_s_1_0@2x.5d6c160f.png";